<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddSpecialTool</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>

      </div>
      <form [formGroup]="addSpecialToolForm" (ngSubmit)="addSpecialTools()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-md-6">
                  <div class="af-form-group">
                    <label for="service" translate>lblBrand
                      <strong class="mlt6 required"> * </strong> </label>
                    <div class='lbl-info'>
                      <div class="form-group">
                        <ng-select class="" formControlName="brand"
                          [ngClass]="{'is-invalid': cpf.brand.invalid && cpf.brand.touched}"
                           placeholder="{{ 'lblSelectBrand' | translate }}">
                          <option disabled [ngValue]="null" translate>lblBrandRequired</option>
                          <ng-template ng-header-tmp>
                            <span class="mbold w-66px">Code</span>
                            <span class="mbold" translate>lblBrand</span>
                          </ng-template>

                          <ng-option *ngFor="let brand of brandList" [value]="brand.brandCode">
                            <span class="w-66px">{{brand.brandCode}}</span>
                            <span class="mx-2 hide-ng-dropdown-panel">-</span>
                            <span>{{brand.brandName}}</span>
                          </ng-option>
                        </ng-select>

                        <div *ngIf="cpf.brand.invalid && (cpf.brand.dirty || cpf.brand.touched)"
                          class="help-block text-danger">
                          <div *ngIf="cpf.brand.errors.required"><span translate>lblBrandRequired</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <label for="service" translate>lblVehicalType</label>
                  <div class="lbl-info">
                    <ng-select formControlName="vehicletype" placeholder="{{ 'lblSelectVehical' | translate }}">
                      <ng-template ng-header-tmp>
                        <span class="mbold w-66px">Code</span>
                        <span class="mbold" translate>lblVehicalType</span>
                      </ng-template>

                      <ng-option *ngFor="let item of vehicleTypes" [value]="item.code">
                        <span class="w-66px">{{item.code}}</span>
                        <span class="mx-2 hide-ng-dropdown-panel">-</span>
                        <span>{{item.name}}</span>
                      </ng-option>
                    </ng-select>
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <label for="service" translate>lblPartNumber </label>
                  <div class='lbl-info'>
                    <input formControlName="partNumber" class="form-control mb-2"
                      [ngClass]="{'is-invalid': cpf.partNumber.invalid && cpf.partNumber.touched}" maxlength="50">
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <label for="service" translate>lblPartGroup </label>
                  <div class='lbl-info'>
                    <input formControlName="partGroup" class="form-control mb-2"
                      [ngClass]="{'is-invalid': cpf.partGroup.invalid && cpf.partGroup.touched}" maxlength="100">
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <label for="service" translate>lblSpecialToolType</label>
                  <div class="lbl-info">
                    <ng-select formControlName="specialToolTypeId" placeholder="{{ 'lblSelectSpecialToolType' | translate }}">
                      <ng-template ng-header-tmp>
                        <span class="mbold" translate>lblSpecialToolType</span>
                      </ng-template>

                      <ng-option *ngFor="let item of specialToolTypes" [value]="item.id">
                        <span>{{item.name}}</span>
                      </ng-option>
                    </ng-select>
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <label for="template-edit-image" translate>lblImage </label>
                  <div class="lbl-info">
                    <div class="custom-file">
                      <label class="btn btn-outline-primary d-inline-block" for="select-files"
                        translate>lblUploadLogo</label>
                      <input type="file" id="select-files" class="" hidden formControlName="image"
                        accept=".png, .jpg, .jpeg" (change)="onChangeFileUpload($event.target.files)">
                    </div>
                    <ng-container *ngIf="specialTool.image">
                      <div *ngIf="specialTool.specialToolImage" class="border mt-3 p-1 d-inline-block">
                        <img height="50" [src]="specialTool.specialToolImage" id="UploadImage"
                          alt="image does not found."
                          onError="this.onerror=null; this.src='../../../../../assets/images/no-image-icon.png'"
                          class="carimg">
                      </div>
                    </ng-container>
                  </div>
                </div>

                <div class="w-100"></div>

                <div class="w-100 px-0" *ngIf="t.controls">
                  <div class="col-md-6" *ngFor="let ticket of t.controls; let i = index">
                    <div [formGroup]="ticket" class="">
                      <div class="af-form-group">
                        <label for="description" translate>lblPartDescription<span> in
                            {{allLanguage[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <input formControlName="description" class="form-control mb-2" required maxlength="200"
                            [ngClass]="{'is-invalid': cpf.partDescription.invalid && cpf.partDescription.touched}">
                          <div *ngIf="cpf.partDescription.touched && (cpf.partDescription.errors?.required)"
                            class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                            lblPartDescriptionRequired
                          </div>
                        </div>
                      </div>
                      <div class="af-form-group" style="display: none;">
                        <label for="languageId" translate>Language Id</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="allLanguage[i].id"
                            required maxlength="30">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align" [disabled]="!addSpecialToolForm.valid"
              translate><em class="far fa-save font16 align-top mr-2"></em>lblSaveChanges</button>
            <a  (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
